/*
 * File: Alerts.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: HOC UI component to render and style out patient alerts
 */
import React from "react";
import AlertList from "./components/AlertList";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PatientChart from "../../topofthechart/PatientChart";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2.5)
  }
});

const PatientAlerts = ({ classes }) => (
  <React.Fragment>
    <PatientChart />
    <Toolbar className={classes.toolbar}>
      <MainHeader pageTitle="Alerts" pageSubtitle="Patient" />
    </Toolbar>
    <AlertList />
  </React.Fragment>
);

PatientAlerts.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PatientAlerts);
